const tripleWidgetSlug = 'coca_bais_before_after_image_slider';

// Handle resize events safely
[ 'resize' ].forEach( ( eventType ) => {
	window.jQuery( window ).on( eventType, function() {
		window.jQuery( `.elementor-widget-${ tripleWidgetSlug } .coca-bais-triple-container` ).each( function() {
			window.jQuery( window ).trigger( 'resize.coca_triple_image_compare' );
		} );
	} );
} );

// Initialize triple sliders on document ready first, not waiting for Elementor
jQuery( document ).ready( function( $ ) {
	$( `.elementor-widget-${ tripleWidgetSlug } .coca-bais-triple-container` ).each( function() {
		const $container = $( this );
		const $options = $container.data( 'settings' );
		if ( typeof $options === 'object' && typeof $container.coca_tripleImageCompare === 'function' ) {
			$container.coca_tripleImageCompare( $options );
		}
	} );
} );

// Then also handle Elementor's initialization if it happens
if ( typeof window.elementorFrontend !== 'undefined' && window.elementorFrontend.hooks ) {
	// Elementor is already loaded, add our action
	window.elementorFrontend.hooks.addAction(
		`frontend/element_ready/${ tripleWidgetSlug }.default`,
		function( $scope ) {
			const $container = $scope.find( '.coca-bais-triple-container' );
			if ( $container.length ) {
				const $options = $container.data( 'settings' );
				if ( typeof $options === 'object' && typeof $container.coca_tripleImageCompare === 'function' ) {
					$container.coca_tripleImageCompare( $options );
				}
			}
		}
	);
} else {
	// Elementor not yet loaded, wait for it
	window.jQuery( window ).on( 'elementor/frontend/init', function() {
		if ( window.elementorFrontend && window.elementorFrontend.hooks ) {
			window.elementorFrontend.hooks.addAction(
				`frontend/element_ready/${ tripleWidgetSlug }.default`,
				function( $scope ) {
					const $container = $scope.find( '.coca-bais-triple-container' );
					if ( $container.length ) {
						const $options = $container.data( 'settings' );
						if ( typeof $options === 'object' && typeof $container.coca_tripleImageCompare === 'function' ) {
							$container.coca_tripleImageCompare( $options );
						}
					}
				}
			);
		}
	} );
}
